import deepmerge from 'deepmerge'
import { IIrisConfigContainerConstParam, IrisConfigContainer } from './IrisConfigContainer'
import { IIrisModContainerConstParam, IrisModContainer } from './IrisModContainer'
import { getDefaultQuickControlConfig, IQuickControlConfig } from './quickControlConfig/IQuickControlConfig'

export class IrisrawModQuickControlConfig extends IrisModContainer<IrisConfigContainer<IQuickControlConfig>> {
  constructor({ ...args }: IIrisModContainerConstParam = {} as IIrisModContainerConstParam) {
    super(args, IrisrawModQuickControlConfig.createIrisrawModQuickControlConfigData)
  }

  static createIrisrawModQuickControlConfig(datas: IIrisModContainerConstParam) {
    return new IrisrawModQuickControlConfig(datas)
  }

  static createIrisrawModQuickControlConfigData(data: IIrisConfigContainerConstParam) {
    return new IrisConfigContainer<IQuickControlConfig>(
      deepmerge({ mod_settings: getDefaultQuickControlConfig() }, data),
    )
  }
}
